export default "__VITE_ASSET__CJX6dTXM__"